/** Inbox that receives account deletion requests. */
export const ACCOUNT_DELETION_CONTACT_EMAIL = "contact@improve.dev";

export type AccountDeletionRequest = {
  email: string;
  /** Optional free-form details from the requester. */
  message: string;
};

/**
 * A `mailto:` URL that opens the visitor's email app with a deletion request already written.
 * Deletion is confirmed by replying from the account's address, so the request needs no sign-in.
 */
export function buildAccountDeletionMailtoUrl({ email, message }: AccountDeletionRequest): string {
  const subject = encodeURIComponent("Haniverse account deletion request");
  const trimmedMessage = message.trim();
  const bodyLines = [
    "Please delete my Haniverse account associated with this email address.",
    "",
    `Email: ${email.trim()}`,
  ];
  if (trimmedMessage.length > 0) {
    bodyLines.push("", "Additional details:", trimmedMessage);
  }
  bodyLines.push("", "Thank you.");
  const body = encodeURIComponent(bodyLines.join("\n"));
  return `mailto:${ACCOUNT_DELETION_CONTACT_EMAIL}?subject=${subject}&body=${body}`;
}
